<template>
  <div>
    <!--begin::Col-->

    <!--end::Col-->

    <!--begin::Col-->
    <!--begin::General Widget 1-->
    <!--begin::General Widget 1-->
    <div class="mb-10">
      <div class="">
        <div class="row align-items-center">
          <div class="col col-11">
            <div class="card-header border-0">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label page-title fw-bolder fs-3 mb-1"
                  >Barrel Management</span
                >
                <!-- <span class="text-muted mt-1 fw-bold fs-7">Active Barrels</span> -->
              </h3>
            </div>
          </div>
          <div class="col">
            <button
                type="button"
                @click="getBarrels()"
            >
                <i class="fas fa-redo fa-2x"></i>

            </button>
          </div>
        </div>


        <input
          type="text"
          class="form-control form-control-lg form-control-solid px-15"
          v-model="search"
          placeholder="Search by Customer Name, Status, PYB# or Barrel#"
          data-kt-search-element="input"
        />
        <!--end::Input-->
        <!--begin::Spinner-->
        <span
          class="
            position-absolute
            top-50
            end-0
            translate-middle-y
            lh-0
            d-none
            me-5
          "
          data-kt-search-element="spinner"
        >
          <span
            class="spinner-border h-15px w-15px align-middle text-muted"
          ></span>
        </span>
        <!--end::Spinner-->
        <!--begin::Reset-->
        <span
          class="
            btn btn-flush btn-active-color-primary
            position-absolute
            top-50
            end-0
            translate-middle-y
            lh-0
            me-5
            d-none
          "
          data-kt-search-element="clear"
        >
          <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
          <span class="svg-icon svg-icon-2 svg-icon-lg-1 me-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <rect
                opacity="0.5"
                x="6"
                y="17.3137"
                width="16"
                height="2"
                rx="1"
                transform="rotate(-45 6 17.3137)"
                fill="black"
              ></rect>
              <rect
                x="7.41422"
                y="6"
                width="16"
                height="2"
                rx="1"
                transform="rotate(45 7.41422 6)"
                fill="black"
              ></rect>
            </svg>
          </span>
          <!--end::Svg Icon-->
        </span>
        <!--end::Reset-->
      </div>

      <div class="spacer-y-10"></div>

      <!--begin::Table container-->
      <v-data-table
        :headers="tableHeaders"
        :items="results"
        item-key="logicalBarrelId"
        class="elevation-1"
        :loading="loadingList"
        loading-text="Loading Barrels..."
      >
        <template v-slot:[`item.status`]="{ item }">
         <div :style="statusStyle(item.status)">{{ formatStatus(item.status) }}</div>
        </template>

        <template v-slot:[`item.removeRetailPackaging`]="{ item }">
          {{ yesNo(item.removeRetailPackaging) }}
        </template>
        <template v-slot:[`item.date`]="{ item }">
          {{ formatDate(item.date) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <span class=""
            ><a
              v-if="isBarrelInAddItemsStatus(item.status)"
              href="#"
              @click.prevent="addItem(item.logicalBarrelId, item.fullness)"
              >Add Item</a
            >
            &nbsp;
            <router-link
              :to="{
                name: 'Manage',
                params: { barrelId: item.logicalBarrelId },
              }"
              >Manage</router-link
            ></span
          >
          &nbsp;
          <span class=""></span>
        </template>
      </v-data-table>
      <!--end::Table-->
    </div>
    <Modal v-if="showModal" @close="showModal = false">
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <AddItem
          :id="selectedBarrel"
          :fullness="selectedBarrelFullness"
          @added="updateBarrels"
        />
      </template>
      <template v-slot:footer>
        <button class="btn btn-primary" @click="showModal = false">Done</button>
      </template>
    </Modal>
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
  </div>
</template>

<script>
import mixins from "vue-typed-mixins";
import { ApiService } from "@/services/ApiService";
import Modal from "@/components/Modal.vue";
import AddItem from "@/components/AddItem.vue";
import { error } from "@/services/LoggerService";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import BarrelStatusMixin, { Status } from "@/mixins/BarrelStatusMixin";

export default mixins(SnackbarNotifierMixin, BarrelStatusMixin).extend({
  name: "AdminBarrelHome",
  components: {
    Modal,
    AddItem,
    SnackbarNotifier,
  },
  data() {
    return {
      loadingList: false,
      barrels: [],
      selectedBarrel: null,
      search: "",
      selectedBarrelFullness: null,
      showModal: false,
      physicalBarrel: "",
      physicalBarrelIds: [""],
      tableHeaders: [
        { text: "Customer", value: "customerName" },
        {
          text: "PYB #",
          value: "pybNumber",
        },
        { text: 'Barrel #', value: 'barrelNum'},
        { text: "Fullness", value: "fullness" },
        { text: "Size", value: "size" },
        { text: "Status", value: "status" },
        { text: "Remove Retail Packaging", value: "removeRetailPackaging" },
        { text: "Date", value: "date" },
        { text: "Actions", value: "actions" },
      ],
    };
  },
  methods: {
    statusStyle(status){
      return "";
    },
    async readyForItems(barrel) {
      if (await this.setStatus(barrel.LogicalBarrelId, "readyForItems"))
        barrel.isSetup = true;
    },
    isBarrelInAddItemsStatus(status) {
      return (
        !!status &&
        (status === Status.ReadyForItems || status === Status.ShipmentRequested)
      );
    },
    async setStatus(barrelId, status) {
      try {
        return await ApiService.Instance.setBarrelStatus({ barrelId, status });
      } catch (e) {
        error(e);
      }
    },
    prepareForSetup(barrel) {
      this.barrel = barrel;
      this.showModal = true;
      this.selectedBarrel = barrel.LogicalBarrelId;
    },
    async assignToPhysicalBarrel() {
      try {
        let result = await ApiService.Instance.addToPhysicalBarrel({
          logicalBarrelIds: [this.selectedBarrel],
          physicalBarrelId: this.physicalBarrel,
        });
        if (result) await this.readyForItems(this.barrel);
      } catch (e) {
        error(e);
      }
    },
    async createPhysicalBarrel() {
      try {
        await ApiService.Instance.createPhysicalBarrel({
          logicalBarrelIds: [this.selectedBarrel],
        });
      } catch (e) {
        error(e);
      }
    },
    yesNo(value) {
      return value ? "Yes" : "No";
    },
   
    async getPhysicalBarrels() {
      try {
        this.physicalBarrelIds = await ApiService.Instance.getPhysicalBarrels();
      } catch (e) {
        error(e);
      }
    },
    async getBarrels() {
      try{
        this.loadingList = true;
        let result = await ApiService.Instance.GetBarrels();
        this.barrels = result.data;
        this.loadingList = false;
      }
      catch(err){
        this.loadingList = false;
        error(err);
      }
    },
    addItem(barrelId, fullness) {
      this.selectedBarrelFullness = fullness;
      this.selectedBarrel = barrelId;
      this.showModal = true;
    },
    async updateBarrels() {
      const vm = this;
      let temp = this.getBarrels;
      setTimeout(async () => {
        vm.$emit('updateNotification');
        await temp();
      }, 1500);
    },
    formatStatus(status) {
      return status.replace(/_/g, " ");
    },
    formatDate(date) {
      return date.split("T")[0];
    },
  },
  computed: {
    results() {
      if (this.search)
        return this.barrels.filter((b) => {
          return (
            b.pybNumber.includes(this.search) ||
            b.customerName.toLowerCase().includes(this.search.toLowerCase()) ||
            b.barrelNum.includes(this.search) ||
            b.status.includes(this.search)
          );
        });
      return this.barrels;
    },
  },
  async beforeMount() {
    try {
      await this.getBarrels();
      if (this.barrels)
        this.showNotifier({
          message: "Successfully Loaded Barrels",
          snackbarType: "success",
        });
    } catch (e) {
      this.showNotifier({
        message: "Failed To Load Barrels",
        snackbarType: "error",
      });
      error(e);
    }
  },
});
</script>
